module.exports = __webpack_public_path__ + "media/images/meta/testbrand/apple-touch-icon-b100d0043eb636f7fb073f2720dac46f.png";